export default __webpack_public_path__ + "static/media/1922.db28a06e.png";